import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskLiveChatTeamChatsRoute } from '@atlassian/jira-router-routes-servicedesk-live-chat-routes/src/servicedeskLiveChatTeamChatsRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import LiveChatTeamChats, { LazyLiveChatTeamChats } from './ui/team-chats/index.tsx';

export const servicedeskLiveChatTeamChatsRouteEntry = createEntry(
	servicedeskLiveChatTeamChatsRoute,
	() => ({
		group: 'servicedesk',
		component: LiveChatTeamChats,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},

		resources: [...getServiceDeskNavigationResources(), getConsolidationStateResource()],

		forPaint: [LazyAtlassianNavigation, LazyLiveChatTeamChats],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-live-chat-entries/src/servicedeskLiveChatTeamChatsRouteEntry.tsx',
				whichExportToUse: 'servicedeskLiveChatTeamChatsRouteEntry',
			},

			enabled: true,
		},
	}),
);
